<ot-global-navbar
  [title]="navbar?.title"
  [links]="links$ | async"
  [helpLinks]="navbar?.helpLinks"
></ot-global-navbar>
